import React from "react";

/**
 * PageLoader — sobrio spinner used as Suspense fallback for lazy-loaded pages.
 *
 * Iter: P1 TECHNICAL HARDENING SPRINT — 2026-02-08
 * Purpose: consistent, minimalistic loading state during route-level code
 * splitting. No brand shift, no marketing claims, no CTA — just a small
 * centered indicator that reassures the user the next chunk is arriving.
 */
export default function PageLoader({ label = "Caricamento…" }) {
  return (
    <div
      data-testid="page-loader"
      role="status"
      aria-live="polite"
      className="min-h-screen flex flex-col items-center justify-center gap-3 bg-white text-[#334155]"
    >
      <div className="w-10 h-10 rounded-full border-2 border-[#E2E8F0] border-t-[#102A43] animate-spin" />
      <div className="text-xs text-[#64748B]">{label}</div>
    </div>
  );
}
